import type { RowData, Table } from '@tanstack/react-table'

export function getColumnFilterLength<TTable extends RowData>(
  table: Table<TTable>
) {
  return table.getState().columnFilters.filter((columnFilter) => {
    const columnFilterValue = columnFilter.value

    if (Array.isArray(columnFilterValue)) return columnFilterValue.length

    return true
  }).length
}
